import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestJobsSkipPost = {
    path: "/jobs/skip",
    method: RouteHttpVerb.POST
};
